/* eslint-disable */
import { BasketRebalancing, MutualFundsSIPs } from '../../store/MFStore'
import EmptyState from '../../Components/Common/EmptyState'
import { TrendingUp } from 'lucide-react'
import { useRecoilValueLoadable } from 'recoil'
import { Checkbox } from '../../Components/ui/checkbox'
import { useEffect, useState } from 'react'
import { toCurrency } from '../../utils/CurrencyUtil'
import { addMonthForModifySIP, capitalizeWords, cleanIndianPhoneNumber } from '../../utils/Util'
import placeholder from '../../assets/placeholder.svg'
import { useModal } from '../../hooks/use-modal-store'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { BASKET_IDS } from '../../constants/sips'
import { Button } from '../../Components/ui/button'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { post } from '../../http/restservice'
import env from '../../env/env'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'


// const dummyPlans = [
//     {
//         customerBasketInvestmentId: '1',
//         basketIndex: 1,
//         customerBasketName: 'Wealth Builder Plan',
//         oneTimeInvestmentAmount: 50000,
//         oneTimeStatus: 'PENDING',
//         sipStatus: 'PENDING',
//         sipInvestmentAmount: 10000,
//         oneTimeInvestmentBreakdown: [
//             {
//                 amcCode: 'HDFC',
//                 schemeName: 'HDFC Flexi Cap Fund',
//                 investmentAmount: 30000,
//                 weightage: 60,
//             },
//             {
//                 amcCode: 'ICICI',
//                 schemeName: 'ICICI Prudential Bluechip Fund',
//                 investmentAmount: 20000,
//                 weightage: 40,
//             },
//         ],
//         sipInvestmentBreakdown: [
//             {
//                 amcCode: 'HDFC',
//                 schemeName: 'HDFC Flexi Cap Fund',
//                 investmentAmount: 6000,
//                 weightage: 60,
//             },
//             {
//                 amcCode: 'ICICI',
//                 schemeName: 'ICICI Prudential Bluechip Fund',
//                 investmentAmount: 4000,
//                 weightage: 40,
//             },
//         ],
//     },
//     {
//         customerBasketInvestmentId: '2',
//         basketIndex: 2,
//         customerBasketName: 'Retirement Growth Plan',
//         oneTimeInvestmentAmount: 100,
//         oneTimeStatus: 'PENDING',
//         sipStatus: 'PENDING',
//         sipInvestmentAmount: 5000,
//         oneTimeInvestmentBreakdown: [],
//         sipInvestmentBreakdown: [
//             {
//                 amcCode: 'SBI',
//                 schemeName: 'SBI Small Cap Fund',
//                 investmentAmount: 2500,
//                 weightage: 50,
//             },
//             {
//                 amcCode: 'AXIS',
//                 schemeName: 'Axis Midcap Fund',
//                 investmentAmount: 2500,
//                 weightage: 50,
//             },
//         ],
//     },
// ]

const calculatePercentageAmount = (parcentage, totalAmount) => {
    const result = totalAmount * (parcentage / 100)
    return Math.ceil(result)
}

const Rebalancing = ({ clientCode, userDetails }) => {

    const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)
    const investedPlans = useRecoilValueLoadable(MutualFundsSIPs)
    const rebalancing = useRecoilValueLoadable(BasketRebalancing)
    const [groupedBaskets, setGroupedBaskets] = useState({})
    const [allPlans, setAllPlans] = useState([])
    const [selectedPlans, setSelectedPlans] = useState([])
    const [loading, setLoading] = useState(false)
    const [newSipBreakdown, setNewSipBreakdown] = useState([])
    const [openOTPPopup, setOpenOTPPopup] = useState(false)

    const { onOpen } = useModal()
    const { showError } = useErrorPopup()
    const adminPlans = allPlans

    const groupByBasketId = (orders) =>
        orders?.filter((order) => order.sipStatus.toLowerCase() === "active")?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
            if (!acc[customerBasketInvestmentId]) {
                acc[customerBasketInvestmentId] = []
            }
            acc[customerBasketInvestmentId].push({ basketStatus, customerBasketInvestmentId, ...order })

            return acc
        }, {})

    useEffect(() => {


        // if (rebalancing?.contents?.message?.includes("No basket sip rebalancing found")) {
        //     setAllPlans([])
        //     return
        // }

        const investedData = investedPlans?.contents?.data || [];
        const rebalancingData = rebalancing?.contents?.data || [];




        const allUserInvestedBaskets = groupByBasketId(investedData);

        const plansMap = new Map();

        rebalancingData.forEach((plan) => {
            if (plan?.customerBasketInvestmentId && plan?.rebalanceStatus === "REQUIRED") {
                plansMap.set(plan.customerBasketInvestmentId, plan);
            }
        });

        const result = [...plansMap.keys()].map((key) => ({
            ...plansMap.get(key),
            sipInvestmentBreakdown: allUserInvestedBaskets?.[key] || [],
        }));

        setAllPlans(result);
    }, [rebalancing, investedPlans]);




    const handleCheckboxChange = (plan) => {
        setSelectedPlans((prev) => {
            const isAlreadySelected = prev.some(
                (p) => p.customerBasketInvestmentId === plan?.customerBasketInvestmentId
            )
            return isAlreadySelected ? [] : [plan]
        })
    }


    const getNewSipBreakdown = (selectedPlan, totalAmount) => {
        const universalBasketId = selectedPlan.universalBasketId
        const basketFunds =
            baskets?.state === 'hasValue'
                ? baskets?.contents?.data?.filter(
                    (plan) => plan.universalBasketId === universalBasketId,
                ) || []
                : []
        const sip_basket = BASKET_IDS[universalBasketId] || {}
        const currentBasketVersion = basketFunds[0]?.versionNumber
        const existingBreakdown = selectedPlan?.sipInvestmentBreakdown || []
        const referenceSip = existingBreakdown[0]
        const usedIndexes = new Set()

        const newUpdatedPlan = Object.entries(sip_basket)
            .filter(([, percentage]) => Number(percentage) > 0)
            .flatMap(([schemeCode, percentage]) => {
                const index = existingBreakdown.findIndex(
                    (p, i) =>
                        !usedIndexes.has(i) &&
                        p.schemeCode?.toLowerCase() === schemeCode.toLowerCase(),
                )

                const basketFund = basketFunds.find(
                    (f) => f.bseSchemeCode?.toLowerCase() === schemeCode.toLowerCase(),
                )

                if (index !== -1) {
                    usedIndexes.add(index)
                    const p = existingBreakdown[index]

                    return [{
                        ...p,
                        installmentAmt: calculatePercentageAmount(totalAmount, percentage),
                        currentBasketVersion,
                    }]
                }

                if (!basketFund) return []

                return [{
                    schemeCode: basketFund.bseSchemeCode,
                    schemeName: basketFund.schemeName,
                    amcCode: basketFund.amcCode,
                    installmentAmt: calculatePercentageAmount(totalAmount, percentage),
                    currentBasketVersion,
                    sipStartDate: referenceSip?.sipStartDate,
                    customerBasketInvestmentId: selectedPlan.customerBasketInvestmentId,
                    customerBasketName: referenceSip?.customerBasketName,
                }]
            })

        setNewSipBreakdown(newUpdatedPlan)
        return newUpdatedPlan
    }




    const generateOTP = async () => {

        setLoading(true)

        const response = await post(
            `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
            {
                phoneNumber: userDetails?.phoneNumber,
                email: userDetails?.email.includes('fabits') ? '' : userDetails?.email,
            },
        )

        if (response.isError) {
            setLoading(false)
            showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => { })
            return
        }

        if (!response.isError) {
            setOpenOTPPopup(true)
        }
    }






    const handleNewSIPRegistration = async () => {


        setLoading(true)

        const newBasketDistribution = getNewSipBreakdown(
            selectedPlans[0],
            selectedPlans[0].totalSipAmount
        )


        if (!newBasketDistribution?.length) {
            setLoading(false)
            showError(
                'SIP Rebalancing Failed',
                'Unable to build the new basket allocation. Please try again later or contact support.',
                () => { },
            )
            return
        }


        const mandateId =
            newBasketDistribution.find((item) => item?.mandateId)?.mandateId ||
            selectedPlans[0]?.sipInvestmentBreakdown?.find((item) => item?.mandateId)?.mandateId

        if (!mandateId) {
            setLoading(false)
            showError(
                'Mandate Issue',
                'There is an issue with your mandate. Please contact our support team for assistance before rebalancing.',
                () => { },
            );
            return
        }

        const newBasketDistributionPayload = newBasketDistribution.map(item => ({
            schemeCode: item.schemeCode,
            installmentAmount: item.installmentAmt,
        }))

        const payload = {
            clientCode: clientCode?.toUpperCase(),
            mandateId,
            currentBasketSips: selectedPlans[0]?.sipInvestmentBreakdown?.map(item => ({
                schemeCode: item.schemeCode,
                folioNumber: item.folioNo,
                sipRegId: item.sipRegId,
            })),

            newBasketDistribution: newBasketDistributionPayload,
            customerBasketInvestmentId: selectedPlans[0]?.customerBasketInvestmentId,
            phoneNumber: cleanIndianPhoneNumber(userDetails?.phoneNumber),
            startDate: addMonthForModifySIP(5, newBasketDistribution[0]?.sipStartDate?.split("/")[0]),
            isRebalanceUpdate: true,
            currentBasketVersion: newBasketDistribution[0]?.currentBasketVersion
        };

        console.log(payload)

        // const updateSIP = await post(`mutualfundservice/api/basket/sipUpdate`, payload)


        if (updateSIP?.isError) {
            setLoading(false)

            showError(
                'SIP Rebalancing Failed',
                'We were unable to rebalance your portfolio. Please try again later or contact support if the issue persists.',
                () => { },
            )
            return
        }

        if (updateSIP?.status === 'SUCCESS') {

            setLoading(false)

            onOpen('openSIPPopup', {
                title: 'Rebalancing Successful',
                message: 'Your portfolio has been rebalanced successfully.',
                severity: 'success',
            })

        }
    }




    return (
        <div className='md:max-w-[760px] lg:max-w-[1128px] mx-4 md:mx-auto mt-2'>
            {/* <div>
                <h1 className='flex justify-between items-center mt-4'>
                    <span className='font-DMSans font-semibold text-lg md:text-xl text-black-500'>
                        Rebalancing
                    </span>
                </h1>
                <p className='font-DMSans md:text-lg text-sm font-normal text-black-400'>
                    Rebalance your portfolio to optimize your returns.
                </p>
            </div> */}

            {adminPlans?.length > 0 && <div className='flex justify-between my-4'>
                <p className='text-sm'>You can select and proceed with one plan at a time, then move on to the next plan.
                </p>
                {/* <span
                    className={`font-DMSans font-medium text-sm ${isAllSelected ? 'text-black-300' : 'text-primary-600'
                        } cursor-pointer`}
                    onClick={() => setIsAllSelected(!isAllSelected)}
                >
                    {isAllSelected ? 'Deselect All' : 'Select All'}
                </span> */}
            </div>}

            <div className='md:flex gap-2 pb-40'>
                {adminPlans?.length > 0 ? <div className='flex-[2] md:grid md:grid-cols-2 lg:grid-cols-2 flex flex-col gap-4 md:gap-4 mb-[170px] overflow-y-scroll hide-scrollbar'>
                    {adminPlans?.map((plan, index) => {

                        return (
                            <div
                                key={plan.customerBasketInvestmentId + index}
                                className={`border border-[#D3DBEC] py-4 px-3 md:p-5 rounded-[6px] overflow-hidden transition-all duration-300 ease-in-out`}
                            >
                                <div className='flex justify-between'>
                                    <div className='flex gap-3 items-start'>
                                        <Checkbox
                                            className='h-5 w-5'
                                            checked={selectedPlans?.some(
                                                (p) =>
                                                    p.customerBasketInvestmentId ===
                                                    plan?.customerBasketInvestmentId
                                            )}
                                            onCheckedChange={() => handleCheckboxChange(plan)}
                                        />
                                        <img src={placeholder} className='h-6 w-6 md:h-8 md:w-8' alt='plan' />
                                        <div className='font-DMSans md:text-lg text-base font-medium'>
                                            {plan?.sipInvestmentBreakdown[0]?.customerBasketName}
                                        </div>
                                    </div>
                                </div>

                                <div className='flex justify-between mt-3'>
                                    <div className='flex-1'>
                                        <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                                            Old SIP
                                        </h1>
                                        <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                                            ₹
                                            {toCurrency(plan?.sipInvestmentBreakdown?.reduce((acc, p) => acc + Number(p.installmentAmt), 0))}

                                        </p>
                                        {plan.sipInvestmentBreakdown && (
                                            <p
                                                className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                                                onClick={() => {
                                                    onOpen('sipBreakdown', {
                                                        constituents: plan?.sipInvestmentBreakdown
                                                    })
                                                }}
                                            >
                                                View Funds
                                            </p>
                                        )}
                                    </div>


                                    <div className='flex-1'>
                                        <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                                            New SIP{' '}
                                            <span
                                                className={`text-xs ${capitalizeWords(plan?.sipStatus) === 'Active'
                                                    ? 'text-secondary-500 bg-secondary-50 rounded-full px-2 border border-secondary-500'
                                                    : 'text-warning-500 bg-warning-50 rounded-full px-2  border border-warning-500'
                                                    }`}
                                            >
                                                {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                                            </span>

                                        </h1>

                                        <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                                            ₹{plan.totalSipAmount ? toCurrency(plan.totalSipAmount) : 0}
                                        </p>

                                        {plan.totalSipAmount > 0 && (
                                            <p
                                                className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                                                onClick={() => {

                                                    onOpen('sipBreakdown', {
                                                        constituents: getNewSipBreakdown(plan, plan.totalSipAmount),
                                                        totalAmount: plan?.totalSipAmount,
                                                    })
                                                }}
                                            >
                                                View Funds
                                            </p>
                                        )}
                                    </div>

                                </div>
                            </div>
                        )
                    })}
                </div> : <EmptyState
                    icon={<TrendingUp className='w-16 h-16 text-success' strokeWidth={1.5} />}
                    title='No Action required'
                    description={
                        <div className='text-left space-y-3'>
                            <p>
                                Rebalancing is the process of realigning your investment portfolio
                                to maintain the right mix of assets based on your goals and risk
                                profile.
                            </p>

                            <p>
                                Over time, different investments grow at different speeds. For
                                example, if equity markets perform very well, your equity
                                allocation may become much higher than originally intended,
                                increasing overall portfolio risk.
                            </p>

                            <p>
                                Rebalancing helps bring the portfolio back to its desired
                                allocation by booking profits from overweight assets and
                                reallocating them to underweight or more stable assets.
                            </p>

                            <div>
                                <p className='font-medium mb-2'>This process helps:</p>

                                <ul className='list-disc pl-5 space-y-1'>
                                    <li>Maintain your intended risk level</li>
                                    <li>Avoid overexposure to a single asset class or strategy</li>
                                    <li>Systematically book profits during market highs</li>
                                    <li>
                                        Improve long-term portfolio discipline and stability
                                    </li>
                                </ul>
                            </div>

                            <p>
                                At Fabits, rebalancing is done thoughtfully based on market
                                conditions, portfolio drift, and your financial goals — not
                                through frequent unnecessary changes.
                            </p>
                        </div>
                    } />}
            </div>

            {adminPlans?.length > 0 && <div
                className={`fixed bottom-0 left-0 right-0 p-4 z-10 lg:max-w-[1128px] mx-auto bg-white mt-2`}
                style={{ boxShadow: '0px 4px 21.6px 0px #00000040', borderRadius: '24px 24px 0px 0px' }}
            >
                <div className='mx-auto space-y-2'>

                    {/* <div className='mt-4'>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        variant={'outline'}
                                        className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                                    >
                                        <span className='text-primary-500 flex items-center gap-x-2'>
                                            <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                                            <p>
                                                SIP starts on -{' '}
                                                <b>
                                                    {addNumberSuffix(sipDate.split('/')[0])}{' '}
                                                    {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                                                    {sipDate.split('/')[2]}
                                                </b>
                                            </p>
                                        </span>

                                        <Pen className='h-4 w-4 text-primary-500' />
                                    </Button>
                                </PopoverTrigger>
                                <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                                    <div className='flex gap-x-2 p-2'>
                                        {sipDates.map((day, index) => (
                                            <Button
                                                key={(day + index).toString()}
                                                className={`h-8 w-8 rounded-full inline-block ${selectedDay !== +day
                                                    ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                                                    : 'text-white'
                                                    }`}
                                                size='simple'
                                                onClick={() => setSelectedDay(+day)}
                                            >
                                                {day}
                                            </Button>
                                        ))}
                                    </div>
                                </PopoverContent>
                            </Popover>
                        </div> */}



                    <Button
                        disabled={selectedPlans?.length === 0}
                        className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-400`}
                        onClick={generateOTP}
                        loading={loading}
                    >
                        Continue
                    </Button>


                    {/* <p className='text-xs mt-2 text-center font-semibold'>
                        Keep your internet banking password ready for quick setup.
                    </p> */}



                </div>
            </div>}

            {adminPlans?.length > 0 && openOTPPopup && (
                <OrderOtpVerification
                    loading={loading}
                    phoneNumber={userDetails?.phoneNumber}
                    openOTPPopup={openOTPPopup}
                    setOpenOTPPopup={setOpenOTPPopup}
                    email={userDetails?.email}
                    handleSipOrOT={handleNewSIPRegistration}
                />
            )}

        </div>
    )
}

export default Rebalancing
